import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=4ae43150&scoped=true"
import script from "./ServiceSummary.vue?vue&type=script&lang=js"
export * from "./ServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=4ae43150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae43150",
  null
  
)

export default component.exports